// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import './styles.css';
import AnalyticsPageView from './components/AnalyticsPageView';
import { initializeAttribution } from './attribution';

initializeAttribution();

const container = document.getElementById('root');
// public/index.html marks prerendered HTML that does not fit this visit.
const canHydrate =
  container.hasChildNodes() &&
  !document.documentElement.classList.contains('prerender-stale');

function Auth0ProviderWithNavigate({ children }) {
  const navigate = useNavigate();
  const onRedirectCallback = React.useCallback(
    (appState) => {
      const requestedPath = appState?.returnTo;
      const safePath =
        typeof requestedPath === 'string' &&
        requestedPath.startsWith('/') &&
        !requestedPath.startsWith('//')
          ? requestedPath
          : '/';
      navigate(safePath, { replace: true });
    },
    [navigate],
  );

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
        client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
      }}
      useRefreshTokens={true}
      useRefreshTokensFallback={false}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}

const app = (
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Auth0ProviderWithNavigate>
      <AnalyticsPageView />
      <App hydrating={canHydrate} />
    </Auth0ProviderWithNavigate>
  </Router>
);

if (canHydrate) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
